// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState('');
    const [user, setUser] = useState(null); 
    const [isAdmin, setIsAdmin] = useState(false); 
    const [formSaved, setFormSaved] = useState(() => {
        const saved = localStorage.getItem('formSaved');
        return saved ? JSON.parse(saved) : false;
    });

    // console.log("User Info", user);
    // Check the local storage for an existing token on component mount
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedToken && storedUser) {
            setToken(storedToken);
            setUser(storedUser)
            setIsAuthenticated(true);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('formSaved', JSON.stringify(formSaved));
    }, [formSaved]);

    const handleSave = async (formData, propertyData) => {
        const url = `${config.apiBaseUrl}/formdata`;
        const method = 'POST';
        // const body = { data: formData, propertyData: propertyData };
        const body = { data: formData, propertyData: propertyData };
    
        try {
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(body)
            });
    
            const result = await response.json();
            if (response.ok) {
                setFormSaved(true); // Update state variable
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Failed to save form data:', error);
        }
    };

    const login = async (newToken, userData) => {
        localStorage.setItem('token', newToken);
        localStorage.setItem('user', JSON.stringify(userData));
        setToken(newToken);
        setIsAuthenticated(true);
        setUser(userData);

        // Wait for the token to be set before proceeding
        await new Promise(resolve => setTimeout(resolve, 0));

        // Retrieve form data and property details from localStorage
        const formData = JSON.parse(localStorage.getItem('formData'));
        const propertyData = JSON.parse(localStorage.getItem('propertyData'));

        if (formData && propertyData) {
            // Call handleSave to save the data to MongoDB
            await handleSave(formData, propertyData);
            // Clear the form data and property details from localStorage
            localStorage.removeItem('formData');
            localStorage.removeItem('propertyData');
        }
        setFormSaved(true); // Update state variable
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setToken('');
        setIsAuthenticated(false);
        setUser(null);
        setIsAdmin(false); 
        window.location.href = '/login';
    };

    useEffect(() => {
        if (user) {
            const userId = user.id || user._id;
            const fetchUserData = async () => {
                if (token) {
                    try {
                        const response = await fetch(`${config.apiBaseUrl}/profile/${userId}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });
                        const data = await response.json();
                        setIsAdmin(data.role === 'admin');
                    } catch (error) {
                        console.error('Error fetching user data:', error);
                    }
                }
            };
            fetchUserData();
        }
    }, [token, user]);


    // Old ADDED FUNCTION TO CONTROL THE ADMIN COMPONENTS
    // useEffect(() => {
    //     const fetchUserData = async () => {
    //       if (token) {
    //         try {
    //           const response = await fetch(`${config.apiBaseUrl}/profile/${user.id}`, {
    //             headers: {
    //               'Authorization': `Bearer ${token}`
    //             }
    //           });
    //           const data = await response.json();
    //         //   console.log("User Data", data);
    //           setIsAdmin(data.role === 'admin');
    //         } catch (error) {
    //           console.error('Error fetching user data:', error);
    //         }
    //       }
    //     };
    
    //     fetchUserData();
    //   }, [token, user]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, token, user, login, logout, isAdmin, formSaved }}>
            {children}
        </AuthContext.Provider>
    );
};
